export const SAVE_DOCUMENTS_IMAGE = 'SAVE_DOCUMENTS_IMAGE'
